import './confirmPopover.css'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import resolveIcon from '../../images/resolved.png';
import cross from '../../images/cross.png';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useLocation } from "react-router-dom";
import { STAKEHOLDER_SIGN_UP_URL } from "../../common/URLs";

export const ConfirmPopover = (props) => {

  const { state } = useLocation();

  const onDashboardClick = (e) => {
    e.preventDefault();
    (props.goToStakeHolderDashboard === 'goToResourceUpdateboard') ? props.navigate('/resourcedashboard/searchByURN') : props.navigate('/dashboardHome/dashboardStakeHolder')
    props.onClose()
  }
  const onClick = (e) => {
    e.preventDefault();
    props.navigate('../home');
    props.onClose()
  }

  const onResourceMappingClick = (e) => {
    e.preventDefault();
    props.navigate('/selectStakeHolder');
    props.onClose()
  }

  const onResourceGrowerHitMappingClick = (e) => {
    e.preventDefault();
    props.navigate('/growerHitMapping');
    props.onClose()
  }
  const onSCMKMClick = (e) => {
    e.preventDefault();
    props.navigate('/resourcedashboard/home');
    // props.onClose()
  }

  const onResourceTransporterMappingClick = (e) => {
    e.preventDefault();
    props.navigate('/resourcedashboard/home');
    // props.onClose()
  }

  const onGotoKMClick = (e) => {
    e.preventDefault();
    props.navigate('/viewKnowledgeManagement');
    // props.onClose()
  }

  const onViewPlantationClick = (e) => {
    e.preventDefault();
    props.navigate('/resourcedashboard/plantationHome/allPlantBatch');
    // props.onClose()
  }

  const onSameScreen = (e) => {
    e.preventDefault();
    props.navigate('/registrationHome/dashboard');
    props.onClose()
  }
  // const onEditTransMappedClick = (e) => {
  //   e.preventDefault();
  //   props.navigate('/viewTransporterMappingRoutes');
  //   props.onClose()
  // }
  const onConsigmentpickupDetails = (e) => {
    e.preventDefault();
    props.navigate('/ConsignmentPickUp', { state: { consignmentNo: state?.consignmentdetails?.consignmentNo } });
    props.onClose()
  }

  const onConsignmenLLECBPickup = (e) => {
    e.preventDefault();
    props.navigate('/LlePickUpDetails', { state: { consignmentNumber: state?.consignmentNoDetails?.consignmentNo } });
    props.onClose()
  }
  
  const onStorageCapacityClick = (e) => {
    e.preventDefault();
    props.navigate('/storageCapacity');
    props.onClose()
  }
  return (
    <div>
      {props.goToRateCardEdit || props.goToRateCard || props.deletePlantation ? <div className='cancel-button'> <IconButton aria-label="close" onClick={props.handleLogModalClose}><CloseIcon /></IconButton></div> : null}
      {/*<div className='cancel-button'> <IconButton aria-label="close" onClick={props.onClose}><CloseIcon /></IconButton></div>*/}
      {props.title1 === "Stackholder not found" ? <div className='error-icon-image'><img src={cross} alt='' /></div> : <div className='confirm-icon-image'><img src={resolveIcon} alt='' /></div>}
      {props.title1 === "Stackholder not found" ? <div><p className='confirm-popup-text'>Stakeholder Not Found </p></div> : <div> <p className={props.goToRateCard ? 'confirm-popup-text confirm-popup-rate-card-text' : 'confirm-popup-text'}>{props.title}</p> </div>}
      {props.showSignupLink === true ? <div><p className='confirm-popup-text'><a href={STAKEHOLDER_SIGN_UP_URL + "&urn=" + props.urn} >Go to SignUp page</a></p></div>
        : props.goToStakeHolderDashboard ? <div onClick={(e) => onDashboardClick(e)}><p className='confirm-popup-text'><a href=''>Go to Dashboard</a></p></div>
          : props.gotoConsignmentPickup ? <div onClick={(e) => onConsigmentpickupDetails(e)}><p className='confirm-popup-text'><a href=''>Ok</a></p></div>
            : props.gotoConsignmenLLECBPickup ? <div onClick={(e) => onConsignmenLLECBPickup(e)}><p className='confirm-popup-text'><a href=''>Ok</a></p></div>
              : props.gotoresDashboard === "gotoresDashboard" ? <div onClick={(e) => onSameScreen(e)}><p className='confirm-popup-text'><a href=''>Ok</a></p></div>
                : props.gotoSameScreen ? <div onClick={(e) => onSameScreen(e)}><p className='confirm-popup-text'><a href=''>Ok</a></p></div>
                  : props.goToViewRescMapping || props.goToRateCardEdit || props.deletePlantation ? <div ><p className='confirm-popup-text'><a href=''></a></p></div>
                    : props.gotoDashboardPlantation === "gotogetAllPlantation" ? <div onClick={(e) => onViewPlantationClick(e)}><p className='confirm-popup-text'><a href="">Go to View Plantation</a></p></div> : props.gotoDashboardPlantation === "gotoDashboard" || props.goToRateCard ? <div onClick={(e) => onClick(e)}><p className={props.goToRateCard ? 'confirm-popup-text confirm-popup-rate-card-text' : 'confirm-popup-text'}><a href="">Go to Dashboard</a></p></div> :
                      props.goToResourceStakeHolderMapping ? <div onClick={(e) => onResourceMappingClick(e)}></div>
                        : props.goToRescGrowerHitMapping ? <div onClick={(e) => onResourceGrowerHitMappingClick(e)}></div>
                          : props.goToStorageCapacity ? <div onClick={(e) => onStorageCapacityClick(e)}></div>
                            : props.goToSCMUpload ? <div onClick={(e) => onSCMKMClick(e)}><p className='confirm-popup-text'><a href="">Go back</a></p></div> : props.goToResourceTransporterStakeHolderMapping ? <div onClick={(e) => onResourceTransporterMappingClick(e)}><p className='confirm-popup-text'><a href="">Go back</a></p></div> : props?.goToKMTable ? <div onClick={(e) => onGotoKMClick(e)}><p className='confirm-popup-text'><a href="">Go back</a></p></div> : !props.hideLink && <div><p className='confirm-popup-text'><a href="/">OK</a></p></div>}
    </div>
  );
};
